import { Button } from '@cian/ui-kit/button';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './ShowPhone.css';

export interface IShowPhoneProps {
  name: string | null;
  withNote: boolean;
  phones: string[];
  showWarningMessage: boolean;
  trackClick(): void;
}

export const ShowPhone: React.FC<IShowPhoneProps> = ({ name, withNote, phones, trackClick, showWarningMessage }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleContainerClick = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();

      setIsOpen(true);

      trackClick();
    },
    [trackClick],
  );

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div className={styles['container']} onClick={handleContainerClick}>
      <Button fullWidth onClick={handleClick} data-name="PhoneButton">
        Показать телефон
      </Button>
      <ModalWindow
        open={isOpen}
        content={
          <div data-name="ShowPhoneModalContent">
            <p className={styles['name']}>{name}</p>
            {phones.map(phone => (
              <div key={phone} className={styles['phone']}>
                {phone}
              </div>
            ))}
            {showWarningMessage && (
              <p className={styles['note']}>Не вносите предоплату до просмотра объекта и заключения договора!</p>
            )}
            {withNote && <p className={styles['note']}>Сообщите владельцу, что вы нашли это объявление на ЦИАН.</p>}
          </div>
        }
        onClose={handleClose}
      />
    </div>
  );
};
